import { Component, HostBinding, OnInit } from '@angular/core';
import axios from 'src/app/Service/axios';
import { Location } from '@angular/common';
import { OtherService } from 'src/app/Service/other.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

@Component({

  selector: 'user',

  templateUrl: './user.component.html',

})

export class UserComponent implements OnInit {

  constructor(private _location: Location,
    private otherService: OtherService,
    private gurdService: GurdServiceService,
  ) { }

  userNumber: any = 0;

  user: any = 0;

  index: number = 0;

  ngOnInit(): void {
    this.getItem();
  }

  getItem = async () => {

    var model = {

      Id: `${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}`,

    };

    const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));

    const resp = await axios.post(`GetUserSubcategory?strSession=${session}`, model);

    this.userNumber = resp.data.length;

    this.user = resp.data;

  };

  goBack() {
    this._location.back();
  }

  getSingel = async (Id: any) => {

    this.index = Id;
  }

  guid(Id: any) {
    this.otherService.guid(Id);
  }
}
